import CardBenchmark from './CardBenchmark';
import './CardBenchmark.scss';

export default CardBenchmark;